import { IncCondDetail } from '@/common/entities/incCond/IncCondDetail';
import { IncCondList } from '@/common/entities/incCond/IncCondList';
import { IncDataSrcDetail } from '@/common/entities/incDataSrc/IncDataSrcDetail';
import { IncDataSrcList } from '@/common/entities/incDataSrc/IncDataSrcList';
import { IncListDetail } from '@/common/entities/incList/IncListDetail';
import { IncListList } from '@/common/entities/incList/IncListList';
import { IncRuleDetail } from '@/common/entities/incRule/IncRuleDetail';
import { IncRuleList } from '@/common/entities/incRule/IncRuleList';
import { EntityView } from '@/common/entityFramework/entityView/EntityView';
import { PriceResLookup } from '@/md/entities/priceRes/PriceResLookup';
import { TierDashboard } from '@/md/entities/tierRes/TierDashboard';
import { Route } from 'react-router-dom';
import { AesProgDetail } from './entities/prog/AesProgDetail';
const AesMdRoutes = [
  <Route path="/md/filter" element={<EntityView />} />,
  <Route
    path="/md/inc-data-src"
    element={<EntityView listComponent={IncDataSrcList} detailComponent={IncDataSrcDetail} />}
  />,
  <Route path="/md/inc-rule" element={<EntityView listComponent={IncRuleList} detailComponent={IncRuleDetail} />} />,
  <Route path="/md/inc-cond" element={<EntityView listComponent={IncCondList} detailComponent={IncCondDetail} />} />,
  <Route path="/md/inc-list" element={<EntityView listComponent={IncListList} detailComponent={IncListDetail} />} />,
  <Route path="/md/tier-dashboard" element={<TierDashboard />} />,
  <Route path="/md/price-lookup" element={<PriceResLookup />} />,
  <Route path="/md/prog" element={<EntityView detailComponent={AesProgDetail} />} />,
];

export default AesMdRoutes;
